import React, { useState, useEffect, useRef } from "react";
import { Autoplay, Scrollbar } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.min.css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./swiper_spc.css";
import { Link } from "react-router-dom";
import spc_data, { Spc_data } from "./spc_data";

interface Spc {
    a: Spc_data;
    res5: number;
}

function SpcPrice(): JSX.Element {
    const [spc] = useState<Spc_data[]>(spc_data);
    const [slidesPerView, setSlidesPerView] = useState<number>(1);
    const [activeSlide, setActiveSlide] = useState<number>(0);
    const swiperRef: React.RefObject<{ swiper: any }> = useRef(null);

    const [res5, setRes5] = useState<number[]>([33, 34, 35, 36, 37, 38, 39, 40, 41]);

    useEffect(() => {
        const updateSlidesPerView = (): void => {
            const windowWidth = window.innerWidth;
            const slidesInView = Math.floor(windowWidth / 500);
            setSlidesPerView(slidesInView);
        };

        updateSlidesPerView();
        window.addEventListener("resize", updateSlidesPerView);
        return () => {
            window.removeEventListener("resize", updateSlidesPerView);
        };
    }, []);

    const handleSlideChange = (swiper: { activeIndex: React.SetStateAction<number> }): void => {
        setActiveSlide(swiper.activeIndex);
    };

    const handleScrollEnd = (): void => {
        if (swiperRef.current) {
            const swiper = swiperRef.current.swiper;
            const slideWidth = swiper.width / slidesPerView;
            const currentTranslate = swiper.translate;
            const newTranslate = Math.round(currentTranslate / slideWidth) * slideWidth;

            swiper.setTransition(300);
            swiper.setTranslate(newTranslate);
        }
    };

    return (
        <div className="spc_slider">
            <Swiper
                ref={swiperRef}
                scrollbar={{
                    hide: false,
                }}
                autoplay={{
                    delay: 3500,
                    disableOnInteraction: false,
                }}
                slidesPerView={slidesPerView}
                spaceBetween={16}
                pagination={{ clickable: true }}
                modules={[Scrollbar, Autoplay]}
                className="mySwiper2"
                onSlideChange={handleSlideChange}
                onScroll={handleScrollEnd}
            >
                {spc.map((a: Spc_data, i: number) => (
                    <SwiperSlide key={i}>
                        <SpcBox a={a} res5={res5[i]} />
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
}

interface SpcBoxProps extends Spc {
    a: Spc_data;
    res5: number;
}

function SpcBox(props: SpcBoxProps): JSX.Element {
    return (
        <div className="spcbox">
            <div className="spcbox_img">
                <Link to={`/detail/${props.res5}`}>
                    <img src={props.a.imgurl} alt={props.a.title} />
                </Link>
                <div className="ranking_spc">
                    <div className="mos_spc">{props.a.mos}</div>
                </div>
            </div>
            <div className="spcbox_txt">
                <Link to={`/detail/${props.res5}`}>{props.a.title}</Link>
                <ul>
                    <li>
                        <span className="persent">{props.a.persent}</span>
                        <span className="saleprice">{props.a.saleprice}</span>
                        <span className="price">{props.a.price}</span>
                    </li>
                </ul>
            </div>
        </div>
    );
}

export default SpcPrice;
